import PageLoader from './components/PageLoader';

const routes = [
	{
		path: '/',
		name: 'home',
		meta: {file: 'home'}
	},
	{
		path: '/auth',
		meta: {file: 'auth'}
	},
	{
		path: '/counter',
		meta: {file: 'counter'}
	},
	{
		path: '/domains/:sub?',
		name: 'domains',
		meta: {file: 'domains'}
	},
	{
		path: '/dashboard',
		name: 'dashboard',
		meta: {file: 'dashboard'}
	},
	{
		path: '/stat',
		name: 'summary',
		meta: {file: 'summary'}
	},
	{
		path: '/stat/:statParam',
		name: 'slices',
		meta: {file: 'slices'}
	},
	{
		path: '/heatmap',
		name: 'heatmap',
		meta: {file: 'heatmap'}
	},
	{
		path: '/video',
		name: 'video',
		meta: {file: 'video'}
	},
	{
		path: '/pageviews',
		name: 'pageviews',
		meta: {file: 'pageviews'}
	},
	{
		path: '/sessions',
		name: 'sessions',
		meta: {file: 'sessions'}
	},
	{
		path: '/recording/:domain/:sessionId/:viewId?',
		name: 'recording',
		meta: {file: 'recording'}
	},
	{
		path: '/integrations/:subTab?',
		meta: {file: 'integrations'}
	},
	{
		path: '/settings/:subTab?',
		meta: {file: 'settings'}
	},
	{
		path: '/restore-account/:email/:expire/:hash',
		meta: {file: 'restore-account'}
	},
	{
		path: '/terms-of-service',
		meta: {file: 'terms-of-service'}
	},
	{
		path: '/privacy-policy',
		meta: {file: 'privacy-policy'}
	},
	{
		path: '/*',
		meta: {file: 'not-found'}
	},
	{
		path: '*'
	}
];
routes.forEach(route => {
	route.component = PageLoader;
});

const router = new VueRouter({
	mode: 'history',
	base: '/',
	routes
});

export default router
